import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";

export const useUploadVesselDocuments = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const vesselId = localStorage.getItem("vesselId");

  const uploadVesselDocuments = async (formData) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/vessel/upload/documents/${vesselId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message);
      }

      return response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return useMutation(uploadVesselDocuments, {
    onSuccess: () => {
      queryClient.invalidateQueries("vesselData");
    },
  });
};
